module.exports = __webpack_public_path__ + "static/media/Oxanium-Regular.f561c6cc.ttf";